import { dataFourDots } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFourDots = /*#__PURE__*/createIcon(dataFourDots)
export default IconFourDots
